import React, { Suspense, lazy } from 'react'
import { styled } from '@mui/system'
import { Modal as BaseModal } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { closeModal } from '../../redux/slices/Modal/modalSlice'
import { MODAL_TYPE } from '../../utils/constants'
import ModalHeader from './components/ModalHeader/ModalHeader'
import { ModalContent } from './ModalApp.style'
import Loader from '../Loader/Loader'
import Entities from './children/Entities/Entities'
const AllocateBlock = lazy(() => import('./children/AllocateBlock/AllocateBlock'))
const FixingSource = lazy(() => import('./children/FixingSource/FixingSource'))
const Cuts = lazy(() => import('./children/Cuts/Cuts'))
const CurrencyPair = lazy(() => import('./children/CurrencyPair/CurrencyPair'))
const PrimeBroker = lazy(() => import('./children/PrimeBroker/PrimeBroker'))
const User = lazy(() => import('./children/User/User'))
const DealReportStatus = lazy(() => import('./children/DealReportStaus/DealReportStatus'))
const Permission = lazy(() => import('./children/Permissions/Permissions'))
const Trader = lazy(() => import('./children/Trader/Trader'))
const TradingAccount = lazy(() => import('./children/TradingAccount/TradingAccount'))

function ModalApp() {
  const modal = useSelector(state => state.modal)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(closeModal())
  }

  const modalBody = () => {
    switch (modal.type) {
      case MODAL_TYPE.ALLOCATE_BLOCK:
        return <AllocateBlock data={modal.data} />
      case MODAL_TYPE.PRIME_BROKER:
        return <PrimeBroker data={modal.data} method={modal.method} />
      case MODAL_TYPE.FIXING_SOURCE:
        return <FixingSource data={modal.data} method={modal.method} />
      case MODAL_TYPE.CUTS:
        return <Cuts data={modal.data} method={modal.method} />
      case MODAL_TYPE.CURRENCY_PAIRS:
        return <CurrencyPair data={modal.data} method={modal.method} />
      case MODAL_TYPE.USERS:
        return <User data={modal.data} method={modal.method} />
      case MODAL_TYPE.DEAL_REPORT_STATUS:
        return <DealReportStatus data={modal.data} />
      case MODAL_TYPE.PERMISSION:
        return <Permission data={modal.data} method={modal.method} />
      case MODAL_TYPE.TRADER:
        return <Trader data={modal.data} method={modal.method} />
      case MODAL_TYPE.TRADING_ACCOUNT:
        return <TradingAccount data={modal.data} method={modal.method} />
      case MODAL_TYPE.ENTITIES:
        return <Entities data={modal.data} method={modal.method} />
      default:
        return <></>
    }
  }

  const modalHeader = () => {
    switch (modal.type) {
      case MODAL_TYPE.ALLOCATE_BLOCK:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.PRIME_BROKER:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.FIXING_SOURCE:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.CUTS:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.CURRENCY_PAIRS:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.USERS:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.DEAL_REPORT_STATUS:
        return (
          <ModalHeader
            title={modal.title}
            dividerStyle={{ marginBottom: '12px', marginTop: '12px' }}
            type={MODAL_TYPE.DEAL_REPORT_STATUS}
          />
        )
      case MODAL_TYPE.PERMISSION:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.TRADER:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.TRADING_ACCOUNT:
        return <ModalHeader title={modal.title} />
      case MODAL_TYPE.ENTITIES:
        return <ModalHeader title={modal.title} />
      default:
        return <></>
    }
  }

  return (
    <Modal open={modal.isOpen} onClose={handleClose} className="modal">
      <Suspense fallback={<Loader />}>
        <ModalContent type={modal.type}>
          {modalHeader()}
          {modalBody()}
        </ModalContent>
      </Suspense>
    </Modal>
  )
}

const Modal = styled(BaseModal)(({ theme }) => ({
  zIndex: 1300,
  right: '50',
  bottom: '50',
  position: 'absolute',
  boxShadow: 24,
  top: '50',
  left: '50',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    minHeight: '100dvh',
    height: '100dvh',
    width: '100dvw',
    overflowX: 'auto',
    overflowY: 'scroll',
    '& .MuiPaper-root': {
      height: '100dvh',
      width: '100dvw',
      paddingBottom: '70px',
      margin: 0,
      boxShadow: 24,
      overflowX: 'auto',
      borderRadius: 0
    }
  }
}))

export default ModalApp
